import EntityBase from '@/data/EntityBase';

import { Map } from 'immutable';

export default class AvailabilityState extends EntityBase({
  dialogs: Map(),
}) {}
